import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_3 = { class: "table table-hover align-middle mt-4" }
const _hoisted_4 = { class: "border-dark border-bottom pb-2" }
const _hoisted_5 = { class: "border-dark border-bottom" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_ProductsOverviewItem = _resolveComponent("ProductsOverviewItem")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_CatalogBuildStatus = _resolveComponent("CatalogBuildStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "has-build-status-on-page": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('ownProducts'),
          "help-text": _ctx.$t('descriptionOwnProductsOverview'),
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, {
          buttons: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_router_link, {
                to: {name: 'new-customer-product'},
                class: "btn btn-hover icon-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["title", "help-text", "onRefresh"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.pageUI.getError()
        }, null, 8, ["error"]),
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaderItems, (tableHeaderItem) => {
                return (_openBlock(), _createElementBlock("th", { key: tableHeaderItem }, _toDisplayString(tableHeaderItem), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (!_ctx.pageUI.isReady())
              ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                  key: 0,
                  "n-cols": _ctx.tableHeaderItems.length
                }, null, 8, ["n-cols"]))
              : (!_ctx.hasProducts)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeaderItems.length,
                      class: "fw-bold small text-uppercase text-muted"
                    }, _toDisplayString(_ctx.$t('noContentFound')), 9, _hoisted_7)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.products.results, (product) => {
                    return (_openBlock(), _createBlock(_component_ProductsOverviewItem, {
                      key: product.product.id,
                      product: product,
                      pageUI: _ctx.pageUI,
                      onDelete: _ctx.deleteItemWithKey
                    }, null, 8, ["product", "pageUI", "onDelete"]))
                  }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_CatalogBuildStatus)
  ], 64))
}